// ../../Public/coming-soon-data.js
import { ASSETS } from './assets-data.js';

export const getComingSoonData = (language) => {
    const data = {
        en: {
            seo: {
                title: "Coming Soon - Always On Air",
                description: "This page is currently under maintenance. We are working hard to bring you the best HVAC and garage door services."
            },
            image: "/placeholder.svg",
            title: "COMING:SOON",
            subtitle: "Under Maintenance",
            description: "We are currently fine-tuning this section to ensure your experience is 'Always On Air'. Check back shortly!",
            buttonText: "Return to Home",
        },
        he: {
            seo: {
                title: "בקרוב - Always On Air",
                description: "דף זה נמצא כעת בתחזוקה. אנחנו עובדים קשה כדי להביא לכם את שירותי מיזוג האוויר ודלתות המוסך הטובים ביותר."
            },
            image: "/placeholder.svg",
            title: "בקרוב:אצלכם",
            subtitle: "בשלבי תחזוקה",
            description: "אנחנו מכווננים את החלק הזה כדי להבטיח שהחוויה שלכם תהיה מושלמת. חזרו אלינו בקרוב!",
            buttonText: "חזרה לדף הבית",
        }
    };
    return data[language] || data.en;
};